import LazyImage from '../LazyImage';
import WithBlaze from '../Products/WithBlaze';
import Surfside from '../Surfside/Surfside';
import { blazeConfigMenuBanners } from '../../config';
import LoadingSpinner from '../LoadingSpinner';
import { useConfig } from "../../contexts/ConfigContext";

const MenuBanners = ({
    banners,
    surfsideBanner,
    rootId,
    setSelectedFilters,
}) => {
    const {
        menuFilter,
        surfside,
    } = useConfig();

    return (
        <div className='headless-menu-banners' id='headlessMenuBanners'>
            {banners ? (
                <div
                    className='headless-banner-slider headless-loop-slider blaze-slider'
                    data-blaze={JSON.stringify(blazeConfigMenuBanners())}
                >
                    <WithBlaze rootId={rootId}>
                        {banners?.map((banner, i) => {
                            const {
                                headless_location_banner_link_type: linkType,
                                headless_location_menu_banner_product_link: productLink,
                                headless_location_menu_banner_custom_link: customLink,
                                headless_location_menu_banner_brand_link: brandLink,
                                headless_location_menu_banner_category_link: categoryLink,
                                headless_location_banner_image_field: imageField,
                            } = banner;

                            let linkDestination,
                                linkFilter,
                                linkName = '';

                            switch (linkType) {
                                case 'brand':
                                    linkFilter = [brandLink];
                                    linkName = 'brandIds';
                                    break;
                                case 'category':
                                    linkFilter = categoryLink;
                                    linkName = 'category';
                                    break;
                                case 'product':
                                    linkDestination = productLink;
                                    break;
                                case 'custom':
                                    linkDestination = customLink;
                                    break;
                                default:
                                    break;
                            }

                            // Check if imageField and its properties exist
                            const imageSrc = imageField?.url || '';
                            const imageSrcSet = imageField?.sizes?.medium_large || '';

                            return (
                                <div
                                    className='headless-menu-banner-single'
                                    role='button'
                                    key={i}
                                    onClick={() => {
                                        if (linkDestination) {
                                            window.open(linkDestination, '_blank');
                                        } else if (linkFilter) {
                                            setSelectedFilters({
                                                ...menuFilter,
                                                [linkName]: linkFilter,
                                            });
                                            const shopDiv = document.getElementById('shop');
                                            const navBar = document.getElementById('topLevelNav');
                                            if (shopDiv && navBar) {
                                                const shopDivTop = shopDiv.getBoundingClientRect().top + window.scrollY;
                                                const navHeight = navBar.offsetHeight + 40;
                                                const scrollToPosition = shopDivTop - navHeight;

                                                window.scrollTo({
                                                    top: scrollToPosition,
                                                    behavior: 'smooth',
                                                });
                                            } else if (shopDiv) {
                                                shopDiv.scrollIntoView({
                                                    behavior: 'smooth',
                                                });
                                            }
                                        }
                                    }}
                                >
                                    <LazyImage
                                        src={imageSrc}
                                        srcSet={imageSrcSet}
                                        alt='menu banner image'
                                    />
                                </div>
                            );
                        })}
                        {surfside?.enable && surfsideBanner && (
                            <Surfside
                                placement='menu-banner'
                                accountId={surfside.account_id}
                                sourceId={surfside.source_id}
                                placementId={surfside.placement_ids?.menu_banner}
                                slider='true'
                            />
                        )}
                    </WithBlaze>
                </div>
            ) : (
                <LoadingSpinner loadingType='menuBanners' />
            )}
        </div>
    );
};

export default MenuBanners;
